import React, { useState, useEffect, useContext } from 'react'
import { Button, Card, Modal } from 'react-daisyui'
import { API } from '../../utils/api'
import { Api } from '../../utils/apiServer'
import moment from 'moment'
import DefaultVoucher from "../../assets/default-voucher.png"
import DefaultProduct from "../../assets/default-product.jpg"
import { ToastContainer, toast } from 'react-toastify'
import { AiOutlineCalendar, AiOutlineShop, AiOutlineEye, AiOutlineLeft, AiOutlineRight, AiOutlineGift, AiOutlineStar, AiOutlineTrophy } from "react-icons/ai"
import { FaCoins } from "react-icons/fa"
const CryptoJS = require("crypto-js")

function Voucher() {
    const [voucher, setVoucher] = useState([])
    const [page, setPage] = useState(1)
    const [lastPage, setLastPage] = useState(1)
    const [loading, setLoading] = useState(true)
    const [selectedVoucher, setSelectedVoucher] = useState(null)
    const [showDetailModal, setShowDetailModal] = useState(false)

    useEffect(() => {
        init();
    }, [])

    useEffect(() => {
        if (page !== 1) {
            init();
        }
    }, [page])

    const init = async () => {
        setLoading(true)
        const params = {
            access: 'auth',
            method: API.VOUCHER.type,
            url: API.VOUCHER.url,
            reqBody: {
                page: page,
                rows: 5
            }
        }
        const response = await Api(params);
        if (response.status) {
            setVoucher(response.data.data)
            setLastPage(response.data.lastPage)
            setPage(response.data.page)
        }
        setLoading(false)
    }

    const handlePrev = () => {
        setPage(page > 1 ? page - 1 : 1)
    }

    const handleNext = () => {
        setPage(page < lastPage ? page + 1 : lastPage)
    }

    const TakeVoucher = async (v) => {
        const params = {
            access: 'auth',
            method: API.REDEEM.type,
            url: API.REDEEM.url,
            reqBody: {
                voucher_id: v.voucher_id
            }
        }

        const response = await Api(params);
        if (response.status) {
            toast.success(response.message)
            // Refresh voucher list after successful redemption
            init()
        } else {
            toast.error(response.message)
        }
    }

    const showVoucher = (v) => {
        setSelectedVoucher(v)
        setShowDetailModal(true)
    }

    const handleCloseModal = () => {
        setShowDetailModal(false)
        setSelectedVoucher(null)
    }

    // Loading skeleton component
    const LoadingSkeleton = () => (
        <div className="animate-pulse space-y-4">
            <div className="bg-gray-200 h-8 rounded w-1/3 mx-auto"></div>
            <div className="grid grid-cols-1 gap-4">
                {[...Array(4)].map((_, i) => (
                    <div key={i} className="bg-gray-200 h-80 rounded-lg"></div>
                ))}
            </div>
        </div>
    )

    // console.log('voucher',voucher)

    if (loading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
                <div className="mx-auto max-w-sm px-5 py-6">
                    <LoadingSkeleton />
                </div>
            </div>
        )
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
            <ToastContainer autoClose={1000} />
            <div className="mx-auto max-w-sm px-5 py-6">
                <div className='flex flex-col space-y-6 scrollbar-hide'>

                    {/* Header Section */}
                    <div className="text-center space-y-2">
                        <div className="flex items-center justify-center space-x-2">
                            <AiOutlineGift className="text-2xl text-purple-600" />
                            <h1 className="text-2xl font-bold text-gray-800">Voucher Tersedia</h1>
                        </div>
                        <p className="text-gray-600 text-sm">Tukarkan poin Anda dengan voucher menarik</p>
                    </div>

                    {/* Voucher Grid */}
                    {voucher.length === 0 ? (
                        <Card className="bg-gradient-to-r from-gray-50 to-white border-2 border-dashed border-gray-300">
                            <Card.Body className="text-center py-12">
                                <AiOutlineGift className="text-6xl text-gray-400 mx-auto mb-4" />
                                <p className="text-gray-500 font-medium text-lg">Belum ada voucher tersedia</p>
                                <p className="text-gray-400 text-sm mt-1">Cek kembali nanti untuk voucher terbaru</p>
                            </Card.Body>
                        </Card>
                    ) : (
                        <div className="grid grid-cols-1 gap-4">
                            {voucher.map((v, i) => (
                                <Card key={i} className="bg-white shadow-lg hover:shadow-xl transition-all duration-300 border-0 overflow-hidden">
                                    <Card.Body className="p-0">
                                        {/* Voucher Image */}
                                        <div className="relative h-48 bg-gradient-to-br from-purple-50 to-pink-50 flex items-center justify-center">
                                            <img
                                                className="h-full w-full object-cover"
                                                src={v?.product_image ? v.product_image : DefaultVoucher}
                                                alt="Voucher"
                                                onError={(e) => {
                                                    e.target.src = DefaultVoucher
                                                }}
                                            />
                                            <div className="absolute top-3 right-3">
                                                <div className="bg-gradient-to-r from-purple-500 to-pink-500 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg">
                                                    {v?.number_point} Poin
                                                </div>
                                            </div>
                                            <div className="absolute top-3 left-3">
                                                <div className="bg-green-500 text-white px-2 py-1 rounded-full text-xs font-semibold">
                                                    Tersedia
                                                </div>
                                            </div>
                                        </div>

                                        {/* Content */}
                                        <div className="p-4 space-y-3">
                                            <div>
                                                <h3 className="font-bold text-lg text-gray-800 leading-tight">
                                                    {v?.name}
                                                </h3>
                                                <div className="flex items-center space-x-1 mt-1">
                                                    <AiOutlineShop className="text-gray-500 text-sm" />
                                                    <span className="text-gray-600 text-sm">{v?.partner?.name}</span>
                                                </div>
                                            </div>

                                            <p className="text-gray-600 text-sm leading-relaxed line-clamp-2">
                                                {v?.description}
                                            </p>

                                            <div className="flex items-center justify-between pt-2 border-t border-gray-100">
                                                <div className="flex items-center space-x-1">
                                                    <AiOutlineCalendar className="text-gray-500 text-sm" />
                                                    <span className="text-gray-600 text-sm">
                                                        {v?.duration} hari
                                                    </span>
                                                </div>
                                                <div className="flex items-center space-x-1">
                                                    <FaCoins className="text-amber-500 text-sm" />
                                                    <span className="text-amber-600 text-sm font-semibold">
                                                        {v?.number_point} poin
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Action Buttons */}
                                            <div className="flex space-x-2 pt-2">
                                                <Button
                                                    size="sm"
                                                    className="flex-1 bg-blue-500 hover:bg-blue-600 text-white border-none"
                                                    onClick={() => showVoucher(v)}
                                                >
                                                    <AiOutlineEye className="mr-1" />
                                                    Lihat
                                                </Button>
                                                <Button
                                                    size="sm"
                                                    className="flex-1 bg-gradient-to-r from-purple-500 to-pink-600 hover:from-purple-600 hover:to-pink-700 text-white border-none"
                                                    onClick={() => TakeVoucher(v)}
                                                >
                                                    <AiOutlineTrophy className="mr-1" />
                                                    Ambil
                                                </Button>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            ))}
                        </div>
                    )}

                    {/* Pagination */}
                    {voucher.length > 0 && (
                        <div className="flex justify-center items-center space-x-4 pt-4">
                            <Button
                                size="sm"
                                variant="outline"
                                disabled={page === 1}
                                onClick={handlePrev}
                                className="border-gray-300"
                            >
                                <AiOutlineLeft className="mr-1" />
                                Previous
                            </Button>

                            <div className="flex items-center space-x-2">
                                <span className="text-sm text-gray-600">Page</span>
                                <span className="bg-purple-500 text-white px-3 py-1 rounded-lg font-semibold">
                                    {page}
                                </span>
                                <span className="text-sm text-gray-600">of {lastPage}</span>
                            </div>

                            <Button
                                size="sm"
                                variant="outline"
                                disabled={page === lastPage}
                                onClick={handleNext}
                                className="border-gray-300"
                            >
                                Next
                                <AiOutlineRight className="ml-1" />
                            </Button>
                        </div>
                    )}
                </div>
            </div>

            {/* Voucher Detail Modal */}
            <Modal open={showDetailModal} onClickBackdrop={handleCloseModal}>
                <Modal.Header className="bg-gradient-to-r from-purple-500 to-pink-600 text-white">
                    <div className="flex items-center space-x-2">
                        <AiOutlineEye className="text-xl" />
                        <span className="font-bold text-lg">Detail Voucher</span>
                    </div>
                </Modal.Header>

                <Modal.Body className="space-y-4 max-h-96 overflow-y-auto">
                    {selectedVoucher && (
                        <>
                            {/* Voucher Image */}
                            <div className="flex justify-center">
                                <img
                                    className='w-full max-w-sm rounded-lg shadow-md'
                                    src={selectedVoucher?.product_image ? selectedVoucher?.product_image : DefaultProduct}
                                    alt="Voucher"
                                    onError={(e) => {
                                        e.target.src = DefaultProduct
                                    }}
                                />
                            </div>

                            {/* Voucher Info */}
                            <div className="space-y-3">
                                <div className="bg-gray-50 p-3 rounded-lg">
                                    <h3 className="font-bold text-lg text-gray-800">{selectedVoucher?.name}</h3>
                                    <p className="text-gray-600 text-sm">{selectedVoucher?.sku}</p>
                                </div>

                                <div className="grid grid-cols-2 gap-4">
                                    <div className="flex items-center space-x-2">
                                        <AiOutlineCalendar className="text-blue-500" />
                                        <div>
                                            <p className="text-xs text-gray-500">Masa berlaku</p>
                                            <p className="font-semibold text-gray-800">
                                                {selectedVoucher?.duration} hari
                                            </p>
                                        </div>
                                    </div>

                                    <div className="flex items-center space-x-2">
                                        <FaCoins className="text-amber-500" />
                                        <div>
                                            <p className="text-xs text-gray-500">Biaya Point</p>
                                            <p className="font-semibold text-amber-600">
                                                {selectedVoucher?.number_point} poin
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex items-center space-x-2">
                                    <AiOutlineShop className="text-green-500" />
                                    <div>
                                        <p className="text-xs text-gray-500">Penyedia</p>
                                        <p className="font-semibold text-gray-800">{selectedVoucher?.partner?.name}</p>
                                    </div>
                                </div>

                                <div>
                                    <h4 className="font-semibold text-gray-800 mb-2">Deskripsi</h4>
                                    <p className="text-gray-600 text-sm leading-relaxed">{selectedVoucher?.description}</p>
                                </div>

                                {/* Redeem Locations */}
                                {selectedVoucher?.partner?.redeem_merchants && selectedVoucher.partner.redeem_merchants.length > 0 && (
                                    <div>
                                        <h4 className="font-semibold text-gray-800 mb-2">Lokasi Penukaran</h4>
                                        <div className="space-y-2">
                                            {selectedVoucher.partner.redeem_merchants.map((location, i) => (
                                                <div key={i} className="bg-gray-50 p-3 rounded-lg border-l-4 border-purple-500">
                                                    <p className="font-medium text-gray-800">{location.name}</p>
                                                    <p className="text-sm text-gray-600">{location.address}</p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </Modal.Body>

                <Modal.Actions className="justify-end space-x-2">
                    <Button variant="outline" onClick={handleCloseModal}>
                        Tutup
                    </Button>
                    <Button
                        className="bg-gradient-to-r from-purple-500 to-pink-600 hover:from-purple-600 hover:to-pink-700 text-white border-none"
                        onClick={() => {
                            TakeVoucher(selectedVoucher)
                            handleCloseModal()
                        }}
                    >
                        <AiOutlineTrophy className="mr-2" />
                        Ambil Voucher
                    </Button>
                </Modal.Actions>
            </Modal>



        </div>
    )
}

export default Voucher